export default __webpack_public_path__ + "static/media/DaCrazy sm.eff20209.svg";